/**
 * @copyright Copyright ToolBelt Data Inc., 2020 All Rights Reserved
 */

import React, { useEffect, useState } from 'react';

import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { Col, Row } from "react-bootstrap";

import styled from "styled-components";
import Container from "../../common/components/layout/Container";
import Panel from "../../common/components/layout/Panel";

import Image from "react-bootstrap/Image";
import BreadCrumb from "../../common/components/BreadCrumb";
import PanelHeader from "../../common/components/layout/PanelHeader";
import SpinnerOverlay from "../../common/components/SpinnerOverlay";
import ContactSection from "./components/ContactSection";
import CompanyDetail from "./components/CompanyDetail";
import SpendSection from "./components/SpendSection";
import CompanySpendReport from "./components/CompanySpendReport";
import AffinitySection from "./components/AffinitySection";
import ViewCompanyDetailHeader from "./components/ViewCompanyDetailHeader";

import { viewCompany } from "./companySlice";
import { CompanyDetailText } from "./Company";

import btIcon from '../../common/assets/img/bt_logo_horizontal.png';
import { APP_COLORS } from "../../common/Constants";


const CompanyProfileView = (props) => {
    const dispatch = useDispatch();
    const history = useHistory();

    const [company, setCompany] = useState({});
    const [breadcrumbItems, setBreadcrumbItems] = useState([]);
    const [insights, setInsights] = useState('');

    const companyState = useSelector(state => state.adminCompany);

    useEffect(() => {
        if (props.match.params.id) {
            console.log('Here my id', props.match.params.id)
            dispatch(viewCompany({id: '2c90bcc9-d46e-4288-a4be-082c0f41b928'}));
        }
    }, [props.match.params.id]);

    useEffect(() => {
        if (companyState.viewCompany) {
            setCompany(companyState.viewCompany);
            setBreadcrumbItems(
                [
                    {label: 'Home', href: '/home', isActive: false},
                    {
                        label: 'Companies',
                        href: '/admin/e/companies',
                        isActive: false
                    },
                    {
                        label: `${companyState?.viewCompany.id}`,
                        href: '',
                        isActive: true
                    },
                    {
                        label: 'View Profile',
                        href: '',
                        isActive: true
                    }
                ]
            );

            const ins = companyState.viewCompany.insights;
            let insights = ins.marketsHighlight + ' ';
            insights += ins.projectsHighlight + ' ';
            insights += ins.typicalProjectValueHighlight + ' ';
            insights += ins.servicesHighlight + ' ';
            insights += ins.profileHighlight + ' ';
            insights += ins.licenseHighlight + ' ';
            insights += ins.permitHighlight + ' ';
            insights += ins.policyHighlight + ' ';
            insights += ins.affinitiesHighlight + ' ';
            insights += ins.affiliationsHighlight + ' ';
            insights += ins.activityHighlight + ' ';

            setInsights(insights);
        }
    }, [companyState.viewCompany]);

    const handleCancel = async () => {
        history.push('/admin/e/companies')
    };

    return (
        <Container>
            <BreadCrumb items={breadcrumbItems}> </BreadCrumb>
            <PanelHeader
                header={`Company - ${company.name || ''}`}
                subHeader={`View Company - ${company.identity || ''}`}
            />
            <Panel>
                {(companyState.loading || !company) && (
                    <SpinnerOverlay />
                )}

                <MainContainer>
                    <Row>
                        <Col xl={6} lg={6} md={6} sm={12}>
                            <ViewCompanyDetailHeader company={company} />
                            <CompanyDetail company={company} />
                            { company.primaryContact && (
                                <ContactSection
                                    contactName={`${company.primaryContact.givenName || ''} ${company.primaryContact.surname || ''}`}
                                    contactPhone={company.primaryContact.phone}
                                    contactEmail={company.primaryContact.email}
                                    contactTitle={company.primaryContact.title}
                                    contactEmailStatus={company.primaryContact.emailVerified}
                                />
                            )}
                            { company.secondaryContact && company.secondaryContact.givenName && (
                                <ContactSection
                                    contactName={`${company.secondaryContact.givenName || ''} ${company.secondaryContact.surname || ''}`}
                                    contactPhone={company.secondaryContact.phone}
                                    contactEmail={company.secondaryContact.email}
                                    contactTitle={company.secondaryContact.title}
                                    contactEmailStatus={company.secondaryContact.emailVerified}
                                />
                            )}
                        </Col>
                        <Col xl={6} lg={6} md={6} sm={12}>
                            <SpendSection company={company} />
                            <CompanySpendReport company={company} />
                            <InsightsSection>
                                <Row>
                                    <Col xs={12}>
                                        <CompanyDetailText fontWeight={'bold'} fontSize={'20'}>Insights</CompanyDetailText>
                                    </Col>
                                    <Col xs={12}>
                                        <CompanyDetailText fontSize={'16'}>
                                            {company['CompanyContractorUniverse.company_class_naics_title_candidates']}
                                        </CompanyDetailText>
                                    </Col>
                                </Row>
                            </InsightsSection>
                            <AffinitySection company={company} />
                        </Col>
                    </Row>
                    <Row style={{ paddingTop: 50, paddingRight: 20 }}>
                        <Col xs={6} style={{ textAlign: 'left', alignContent: 'flex-end' }}>
                            <CompanyDetailText fontSize={'14'} color={APP_COLORS['gray-600']} style={{ fontStyle: 'italic' }}>
                                {insights}
                            </CompanyDetailText>
                        </Col>
                        <Col xs={6} style={{ textAlign: 'right' }}>
                            <Image
                                src={btIcon}
                                alt="Is BT Icon"
                                height={40}
                            />
                        </Col>
                    </Row>
                </MainContainer>

                {/*<FormContainer>*/}
                {/*    <Form noValidate>*/}
                {/*        <Form.Group controlId="viewAsJSON">*/}
                {/*            <Row>*/}
                {/*                <Col xl={12} lg={12} md={12} sm={12} className="buttons">*/}
                {/*                    <Button*/}
                {/*                        className="btn-min-width-120 btn-height-35"*/}
                {/*                        style={{marginLeft: "10px"}}*/}
                {/*                        variant="info"*/}
                {/*                        onClick={() => {*/}
                {/*                          handleCancel().then();*/}
                {/*                        }}*/}
                {/*                    >CANCEL*/}
                {/*                    </Button>*/}
                {/*                </Col>*/}
                {/*            </Row>*/}
                {/*        </Form.Group>*/}
                {/*    </Form>*/}
                {/*</FormContainer>*/}
            </Panel>
        </Container>
    );
}

export default CompanyProfileView;

const MainContainer = styled.div`
    width: 100%;
    max-width: 1280px;
  
    margin-bottom: 20px;
`;

const InsightsSection = styled.div`
    margin: 20px;
`;



